import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';

const OfferBannerManager = () => {
  const [banners, setBanners] = useState([]);
  const [title,   setTitle]   = useState('');
  const [image,   setImage]   = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg,     setMsg]     = useState({ text:'', type:'' });

  const fetchBanners = async () => {
    try {
      const res = await axiosInstance.get('/auth/add-offer-banner');
      setBanners(res.data.banners || []);
    } catch { setMsg({ text:'Failed to fetch banners.', type:'error' }); }
  };

  useEffect(() => { fetchBanners(); }, []);

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async e => {
    e.preventDefault();
    if (!image || !title.trim()) {
      setMsg({ text:'Please provide both title and image.', type:'error' });
      return;
    }
    const fd = new FormData();
    fd.append('title', title);
    fd.append('image', image);
    setLoading(true);
    try {
      await axiosInstance.post('/auth/admin/add-offer-banner', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMsg({ text:'Banner uploaded successfully!', type:'success' });
      setTitle(''); setImage(null); setPreview(null);
      fetchBanners();
    } catch { setMsg({ text:'Failed to upload banner.', type:'error' }); }
    finally  { setLoading(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this banner?')) return;
    try {
      await axiosInstance.delete(`/auth/admin/add-offer-banner/${id}`);
      setMsg({ text:'Banner deleted.', type:'success' });
      fetchBanners();
    } catch { setMsg({ text:'Failed to delete banner.', type:'error' }); }
  };

  return (
    <div className="offer-page">
      <div className="ph">
        <div><h1>Offer Banners</h1><p>Upload and manage promotional banners</p></div>
      </div>

      {msg.text && (
        <div className={`alert alert-${msg.type === 'success' ? 'success' : 'error'}`} style={{ marginBottom:14 }}>
          {msg.text}
          <button className="alert-close" onClick={() => setMsg({ text:'', type:'' })}>✕</button>
        </div>
      )}

      {/* Upload form */}
      <div className="offer-upload-card">
        <div className="offer-upload-title">Upload New Banner</div>
        <form onSubmit={handleUpload}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
            <div className="form-group" style={{ margin:0 }}>
              <label className="form-label">Banner Title</label>
              <input className="form-control" value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. Summer Sale" required />
            </div>
            <div className="form-group" style={{ margin:0 }}>
              <label className="form-label">Image</label>
              <label className="file-input-wrap">
                <input type="file" accept="image/*" onChange={handleImageChange} />
                <span className="file-input-label">
                  {image ? image.name : <><span>Choose file</span> or drag here</>}
                </span>
              </label>
            </div>
          </div>
          {preview && (
            <img src={preview} alt="preview" style={{ height:80, borderRadius:6, objectFit:'cover', marginBottom:10, border:'1px solid var(--border)' }} />
          )}
          <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
            <i className="fas fa-upload" /> {loading ? 'Uploading…' : 'Upload Banner'}
          </button>
        </form>
      </div>

      {/* Banner grid */}
      {banners.length === 0 ? (
        <div className="empty-state" style={{ padding:40 }}>
          <i className="fas fa-image" style={{ fontSize:32, color:'var(--t3)' }} />
          <p>No banners uploaded yet</p>
        </div>
      ) : (
        <div className="offer-grid">
          {banners.map(b => (
            <div key={b._id} className="offer-card">
              <img src={b.image?.url} alt={b.title} className="offer-img" />
              <div className="offer-card-body">
                <span className="offer-card-title" title={b.title}>{b.title}</span>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(b._id)}>
                  <i className="fas fa-trash" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OfferBannerManager;
